import { jsx as _jsx } from 'react/jsx-runtime'
import { forwardRef } from 'react'
const SvgIconStarActive = (props, ref) =>
  _jsx('svg', {
    viewBox: '0 0 24 24',
    xmlns: 'http://www.w3.org/2000/svg',
    width: '1em',
    height: '1em',
    fill: 'currentColor',
    ref: ref,
    ...props,
    children: _jsx('path', {
      d: 'M10.615 4.33c.512-1.232 2.258-1.232 2.77 0l1.173 2.82a1.5 1.5 0 0 0 1.265.919l3.044.244c1.33.106 1.869 1.766.856 2.634l-2.32 1.987a1.5 1.5 0 0 0-.483 1.487l.709 2.97c.31 1.298-1.102 2.324-2.241 1.628l-2.606-1.591a1.5 1.5 0 0 0-1.564 0l-2.606 1.591c-1.139.696-2.55-.33-2.24-1.628l.708-2.97a1.5 1.5 0 0 0-.484-1.487l-2.319-1.987c-1.013-.868-.474-2.528.856-2.634l3.044-.244a1.5 1.5 0 0 0 1.265-.92l1.173-2.82Z',
    }),
  })
const ForwardRef = forwardRef(SvgIconStarActive)
export default ForwardRef
